import { Base } from "../../framework/common/base";
import { AppUtils } from "../common/appUtils";
import { WorkShiftTimeSlotState } from "../common/enums";

export enum WorkTimeTypeType
{
    Break = 0,
    Driving = 1,
    Loading = 2,
    UnLoading = 3,
    Waiting = 4,
    Other = 5
}

export enum WorkTimeEventType {
    WorkTimeStarted = 1,
    WorkTimeEnded = 2
}

// API has more properties
// These are the ones in use.
export interface IWorkShiftTimeSlot {
    id: string;
    workShiftId?: string;
    rowId: string;
    costCenterId: string;
    vehicleId: string;
    vehicleRegisterNumber: string;
    state: WorkShiftTimeSlotState;
    startDate: string;
    orgStartDate: string;
    endDate: string;
    orgEndDate: string;
    comment: string;
    costCenterName: string;
    costCenterComment: string;
    customerName: string;
    workTimeTypeId: string;
    workTimeTypeName: string;
    workTimeTypeType: WorkTimeTypeType;
    salaryRowTypeId: string;
    salaryRowTypeName: string;
    timeZoneName: string;
    automatic: boolean;
    workTimeEvents?: {
        type: WorkTimeEventType;
        source: string;
        time: string;
    }[];
    isCustomType: boolean;
    customerId: string;
}

// Duration minutes with minute accuracy
export const getWorkShiftTimeSlotDurationMinutes = (
    slot: IWorkShiftTimeSlot
): number => {
    return Base.dateDiffInMinutes(
        Base.dateToMinuteAccuracy(slot.startDate),
        Base.dateToMinuteAccuracy(slot.endDate || new Date())
    );
};

// Duration minutes string
export const getWorkShiftTimeSlotDurationStr = (
    slot: IWorkShiftTimeSlot
): string => {
    return AppUtils.getDurationStrByDurationMinShort(
        getWorkShiftTimeSlotDurationMinutes(slot),
        true
    );
};
